import React from 'react';
import RFP_PDF_URL from "./../../assets/doc/IFSPD_Host_University_RFP.pdf";

function AcademyTender() {
  return (
    <main id="main">
        <div className="c-app c-default-layout">
            <div className="container">
                <div className="section-header section-header-1">
                    <h1 className="title mb-2">TENDERS</h1>
                </div>

                <div className="row justify-content-center pt-4">
                    <div className="ps-4 pe-4">
                     
                        <div className="d-block d-md-flex mb-4 justify-content-between align-items-center">
                            <div>
                                <h2 className="fw-bold text-uppercase fs-3 m-0">Request for Proposal (RFP)</h2>
                            </div>
                            
                            {/* Download Button */}
                            <a 
                                href={RFP_PDF_URL} 
                                download="IFSPD_University_RFP_2026.pdf"
                                className="btn btn-primary mt-2 mt-md-0 text-white"
                            >
                                Download PDF Copy
                            </a>
                        </div>

                        {/* 2. Embedded PDF Container */}
                        <div className="b-rad-5 border overflow-hidden w-100" style={{ height: '800px' }}>
                
                            <object
                                data={RFP_PDF_URL}
                                type="application/pdf"
                                width="100%"
                                height="100%"
                            >
                                {/* Fallback content for older mobile browsers */}
                                <div className="bg-light p-5 text-center">
                                    <p className="fs-16p">
                                        Your browser doesn't support inline PDF viewing.
                                    </p>
                                    <a 
                                        href={RFP_PDF_URL} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="text-decoration-underline fw-bold text-primary"
                                    >
                                        Click here to open the REQUEST FOR PROPOSAL (RFP)
                                    </a>
                                </div>
                            </object>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </main>
  );
}

export default AcademyTender;